
import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { tap } from 'rxjs/operators';
import { SelectItem } from 'primeng/components/common/api';
import { ClassificationService } from 'app/services/classification/classification.service';
import { StoreCommonService } from './../../../../services/store/store-common.service';

@Component({
  selector: 'app-store-common-classification',
  templateUrl: './store-common-classification.component.html'
})
export class StoreCommonClassificationComponent implements OnInit {
  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() editMode: boolean;
  @Input() storeId: any;

  classificationTypes: { name: string, id: number }[] = [];
  classificationDetails: Array<SelectItem[]> = [];
  selectedClassifications: any = {};

  constructor(
    private classificationService: ClassificationService,
    private storeService: StoreCommonService
  ) { }

  ngOnInit(): void {
    this.loadClassifications();
  }

  loadClassifications(): void {
    // Svuota le liste prima di caricare i nuovi dati
    this.classificationTypes = [];
    this.classificationDetails = [];

    this.classificationService.getClassificationTypes('store').subscribe(
      cTypes => {
        const detailRequests = cTypes.map((ct, i) => {
          this.classificationTypes.push({ name: ct.name, id: ct.id });
          this.classificationDetails.push([{ value: null, label: '' }]);
          return this.classificationService.getDetails(ct.id).pipe(
            tap(ctDetails => {
              ctDetails.forEach(cd => {
                this.classificationDetails[i].push({ value: cd.id, label: cd.description });
              });
            })
          );
        });

        Observable.forkJoin(detailRequests).subscribe(
          () => {
            if (this.editMode) {
              this.getStoreClassifications();
            }
          },
          error => console.error(error)
        );
      },
      error => console.error(error)
    );
  }


  getStoreClassifications() {
    this.storeService.getStoreClassifications(this.storeId).subscribe(storeClassifications => {
      this.classificationTypes.forEach(ct => {
        storeClassifications
          .filter(sc => ct.id === sc.classification_type_id)
          .forEach(f => this.selectedClassifications[f.classification_name] = f.classification_detail_id)
      });
    });
  }

  save(storeId: number) {
    const data: { classification_detail_id: number }[] = [];
    if (Object.keys(this.selectedClassifications).length > 0) {
      for (const key in this.selectedClassifications) {
        if (this.selectedClassifications[key]) {
          data.push({ classification_detail_id: this.selectedClassifications[key] });
        }
      }
    }
    this.storeService.putStoreClassification(storeId, data).subscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-classification/store-common-classification.component.ts